import { useEffect } from "react";
import {
  enableNotificationSoundOnInteraction,
  setAlertSoundActive,
} from "../../commonFunctions/notificationSound";
import { syncOrderTracking, useNewOrderHighlights } from "../../commonFunctions/newOrderHighlights";
import { useVendorOrdersHub } from "../../commonFunctions/vendorOrdersHub";

// Nothing is drawn here. It looks for new orders and sounds the siren while any new order has not
// been accepted yet; the order cards blink red for the same orders (see newOrderHighlights).

const ORDER_CHECK_INTERVAL_MS = 15000;

export const NewOrderSiren = () => {
  const { newOrderCount } = useNewOrderHighlights();

  // The siren can only start after the user has interacted with the page
  useEffect(() => {
    enableNotificationSoundOnInteraction();
  }, []);

  // Look for new orders when the app opens, every 15 seconds, when the tab is shown again, and as
  // soon as a notification arrives or the live connection pushes something
  useEffect(() => {
    syncOrderTracking();
    const check = () => {
      if (document.visibilityState === "visible") syncOrderTracking();
    };
    const timer = setInterval(check, ORDER_CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", check);
    };
  }, []);
  useVendorOrdersHub(() => {
    syncOrderTracking();
  });

  const hasNewOrders = newOrderCount > 0;
  useEffect(() => {
    setAlertSoundActive(hasNewOrders);
    return () => setAlertSoundActive(false);
  }, [hasNewOrders]);

  return null;
};

export default NewOrderSiren;
